// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");
var QwickAppstoreBadgeSvg = require("../../img/qwick-appstore-badge.svg").default;
var QwickGooglePlayBadgeSvg = require("../../img/qwick-google-play-badge.svg").default;

var make = QwickAppstoreBadgeSvg;

var AppStoreImage = {
  make: make
};

var make$1 = QwickGooglePlayBadgeSvg;

var GooglePlayStoreImage = {
  make: make$1
};

var image = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.px(60)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.px(200)),
        tl: /* [] */0
      }
    });

var Styles = {
  image: image
};

function BrowserComponents_GetAppButtons$Base(Props) {
  var appStoreUrl = Props.appStoreUrl;
  var className = Props.className;
  var googlePlayUrl = Props.googlePlayUrl;
  var tmp = {
    children: null
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_FlexColumn.make, tmp, React.createElement("a", {
                  href: appStoreUrl
                }, React.createElement("div", {
                      className: image
                    }, React.createElement(make, {}))), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement("a", {
                  href: googlePlayUrl
                }, React.createElement("div", {
                      className: image
                    }, React.createElement(make$1, {}))));
}

var Base = {
  AppStoreImage: AppStoreImage,
  GooglePlayStoreImage: GooglePlayStoreImage,
  Styles: Styles,
  make: BrowserComponents_GetAppButtons$Base
};

function BrowserComponents_GetAppButtons$Business(Props) {
  var className = Props.className;
  var tmp = {
    appStoreUrl: "https://go.qwick.com/applebusiness",
    googlePlayUrl: "https://go.qwick.com/androidbusiness"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_GetAppButtons$Base, tmp);
}

var Business = {
  make: BrowserComponents_GetAppButtons$Business
};

function BrowserComponents_GetAppButtons$Professional(Props) {
  var className = Props.className;
  var tmp = {
    appStoreUrl: "https://apps.apple.com/us/app/qwick-professionals/id1458652766",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=com.qwickmobile"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement(BrowserComponents_GetAppButtons$Base, tmp);
}

var Professional = {
  make: BrowserComponents_GetAppButtons$Professional
};

exports.Base = Base;
exports.Business = Business;
exports.Professional = Professional;
/* make Not a pure module */
